import moment from "moment";

export const issuedVoucherStatus = (voucher = {}, now = moment()) => {
  if ([false, 0, "0"].includes(voucher.is_active)) return "Inactive";
  const balance = voucher.remaining_balance;
  const amount = balance && typeof balance === "object" ? Number(balance.amount_minor) / 100 : Number(balance);
  if (balance !== null && balance !== undefined && balance !== "" && Number.isFinite(amount) && amount <= 0) return "Redeemed";
  const expiry = moment(voucher.expiry_at);
  if (voucher.expiry_at && expiry.isValid() && now.isAfter(expiry)) return "Expired";
  return "Active";
};
